<template>
    <div class="page-search">
        <div class="search">
            <div class="search-iptBox">
                <form :action="res_searchPlaceholder.url || '/'" method="get" onsubmit="return false">
                    <input class="search-text"
                        ref="searchInput"
                        type="search"
                        name="keyword"
                        v-model="searchVal"
                        @focus="event_unbindPageMainScroll"
                        @input="event_getSearchResult"
                        @keyup="event_setLocalStorage"
                        :placeholder="res_searchPlaceholder.keyword || '搜索：分类 品牌 系列 商品'"
                        autocomplete="off"
                        autocorrect="off"
                        maxlength="40"
                        autofocus="autofocus"
                    />
                    <!-- <input type="hidden" name="b" value="b" />
                    <input type="hidden" name="c" value="c" /> -->
                </form>
            </div>
            <i class="iconfont icon-search search-icon"></i>
            <span class="search-clearInput" @click.prevent="event_clearSearchVal" v-show="isShowBtnClearSearch">
                <i class="iconfont icon-clearInput"></i>
            </span>
            <a class="search-btnCancel" href="#" @click.prevent="event_btnCancel">取消</a>
        </div>

        <div class="page-main"
            ref="pageMain"
            :class="{'page-main--hidden': isPageHidden}"
            @touchstart="event_doSearchInputBlur"
            @scroll="event_pageMainSscroll"
        >
            <div class="page-mainCnt">
                <div class="mod-area" v-if="res_hotTopic.name1 || res_hotTopic.name2 || res_hotKeys.length">
                    <div class="mod-head">
                        热销推荐
                    </div>
                    <ul class="listTxt listTxt--hot" v-if="res_hotTopic.name1 || res_hotTopic.name2">
                        <li class="listTxt-item" v-if="res_hotTopic.name1">
                            <a :href="res_hotTopic.topicId1" @click="event_hotTopic({
                                keyword: res_hotTopic.name1 || '',
                                input_mode: '热门搜索',
                                screen_name: from,
                                class_id: ''
                            })">{{ res_hotTopic.name1 || '' }}</a>
                        </li>
                        <li class="listTxt-item" v-if="res_hotTopic.name2">
                            <a :href="res_hotTopic.topicId2" @click="event_hotTopic({
                                keyword: res_hotTopic.name2 || '',
                                input_mode: '热门搜索',
                                screen_name: from,
                                class_id: ''
                            })">{{ res_hotTopic.name2 || '' }}</a>
                        </li>
                    </ul>
                    <ul class="listTxt listTxt--hot" v-else>
                        <li class="listTxt-item" v-for="num in 2"></li>
                    </ul>
                    <ul class="listTxt" v-if="res_hotKeys.length">
                        <li class="listTxt-item" v-for="(hotKey, index) in res_hotKeys" v-if="index <= 5">
                            <a href="#" @click.prevent="event_toPageList(
                                hotKey.key,
                                {
                                    keyword: hotKey.key,
                                    input_mode: '热门搜索',
                                    screen_name: from,
                                    class_id: ''
                                }
                            )">
                                {{ hotKey.key }}
                            </a>
                        </li>
                    </ul>
                    <ul class="listTxt" v-else>
                        <li class="listTxt-item" v-for="num in 6"></li>
                    </ul>
                </div>
                <div class="mod-area mt20 mode-area--searchHistory" v-if="searchValList.length">
                    <div class="mod-head">
                        搜索历史
                        <span class="btn-clearHistory" @click="event_clearSearchHistory">
                            <i class="iconfont icon-clearHistory"></i>
                        </span>
                    </div>
                    <ul class="listTxt listTxt--normal">
                        <li class="listTxt-item" v-for="item in reverseSearchValList">
                            <!-- <router-link
                                :to="{
                                    name: 'list',
                                    query: {
                                        keyword: item
                                    }
                                }"
                            >
                                {{ item }}
                            </router-link> -->
                            <a href="#" @click.prevent="event_toPageList(
                                item,
                                {
                                    keyword: item,
                                    input_mode: '搜索历史',
                                    screen_name: from,
                                    class_id: ''
                                }
                            )">
                                {{ item }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="mod-area mt20" v-if="res_mix.length">
                    <div class="mod-head">
                        常用分类
                    </div>
                    <ul class="listTxt" v-if="res_mix.length">
                        <li class="listTxt-item" v-for="(item, index) in res_mix"
                            @click="dp_Search(
                                {
                                    keyword: item.name,
                                    input_mode: '常用分类',
                                    screen_name: from,
                                    class_id: item.orgCode
                                }
                            )"
                        >
                            <router-link
                                :to="{
                                    name: 'list',
                                    query: {
                                        type: 'category',
                                        keyword: item.name,
                                        categoryId: item.orgCode,
                                        from: from //添加跳转至列表页的来源
                                    }
                                }"
                                replace
                            >
                                {{ item.name }}
                            </router-link>
                        </li>
                    </ul>
                    <ul class="listTxt" v-else>
                        <li class="listTxt-item" v-for="num in 6"></li>
                    </ul>
                </div>
                <div class="mod-like mt20">
                    <div class="mod-head">
                        猜你喜欢
                    </div>
                    <m-goodsList
                        v-bind="{
                            api: api_getRecommend,
                            data: {
                                type: 'search',
                                count: 40,
                            },
                            from: from

                        }"
                    ></m-goodsList>
                </div>
            </div>
        </div>
        <div class="page-main page-main--bgWhite" v-show="isShowSearchResult" @touchstart="event_doSearchInputBlur">
            <div class="listSrchBox">
                <ul class="brand" style="display: none;">
                    <li class="brand-item">
                        <div class="brand-row">
                            <div class="brand-name">VALENTINO VALENTINOVALENTINOVALENTINOVALENTINOVALENTINO</div>
                            <span class="brand-enter">进入品牌</span>
                        </div>
                        <p class="brand-size">
                            在售商品200件
                        </p>
                    </li>
                </ul>
                <ul class="schResList">
                    <li v-for="item in res_display">
                        <a href="#" @click.prevent="event_toPageList(
                            item.keyword,
                            {
                                keyword: item.keyword,
                                input_mode: '联想词',
                                screen_name: from,
                                class_id: ''
                            }
                        )">
                            {{ item.keyword }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
//引入组件
import MDialog from '@/components/MDialog';
import MGoodsList from '@/components/MGoodsList';

//引入JS
import { mapMutations, mapActions } from 'vuex';
let SEC = require('common/js/utils/core.js');
import LS from 'common/js/utils/baseLocalStorage';
import {
    getLocationSearch
} from '@/public/js/public.js';

//引入配置
import {
    COOKIE_MAX_AGE
} from '@/config';

//引入API接口
import {
    api_getKeywordRecommend, //输入框默认提示文案
    api_getHotTopic, //获取热门栏目推荐
    api_getHotkey, //热销推荐
    api_getCommRecommend, //常用分类
    api_getRecommend, //猜你喜欢
    api_getSearchSuggest, //搜索推荐-联想词 新suggest
} from '@/api';


export default {
    name: "",
    props: {
        // 搜索关键词
        searchKeyword: {
            type: String,
            default: ''
        },
        // 来源于，比如：调起搜索的是首页index，还是列表页
        from: {
            type: String,
            default: ''
        },
        // 是否搜索列表页
        isPageList: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            searchVal: this.searchKeyword || '', //搜索框值
            isShowBtnClearSearch: false, //是否显示搜索清除按钮
            isShowSearchResult: false, //是否显示搜索结果项
            isShowSearchHistory: false, //是否显示搜索历史
            isPageHidden: false, //是否给页面添加overflow: hidden;

            storage: new LS(), //创建实例
            searchValList: [], //搜索值列表

            api_getRecommend, //猜你喜欢

            // 打点统计的事件名称，现用-神策
            doPointEvents: [
                'Search', // 事件名：搜索
                'SearchResultClick', // 事件名：搜索后点击
                'recommendClick', // 事件名：推荐点击
            ],

            res_searchPlaceholder: '', //搜索框placeholder值
            res_hotTopic: {}, //获取热门栏目推荐
            res_hotKeys: {}, //热销推荐
            res_mix: [], //常用分类
            res_display: [] //搜索推荐-联想词 新suggest
        };
    },
    computed: {
        reverseSearchValList(){
            return JSON.parse(JSON.stringify(this.searchValList)).reverse();
        }
    },
    created(){
        this.initQS(); //初始化获取url参数列表
        this.api_getKeywordRecommend(); //输入框默认提示文案
        this.api_getHotTopic(); //获取热门栏目推荐
        this.api_getHotkey(); //热销推荐
        this.api_getCommRecommend(); //常用分类

        //初始化history
        this.initSearchHistory();
    },
    mounted: function(){
        //console.log(this.searchKeyword);
        this.scrollPageMainDoSearchInputBlur();
        this.autoFocus(); //输入框自动获取焦点
    },
    methods: {
        //初始化获取url参数列表
        initQS(){
            let params = [
                    'page' //页面来源；不存在时，则为default
                ];
            SEC.string.get_urlParams(params, this);
            this.QS_search = getLocationSearch();
        },

        //页面内容区滚动
        event_pageMainSscroll(){
            this.lazyLoad();
        },

        lazyLoad(){
            let aImgBox = document.querySelectorAll('.listGoods-imgBox[data-src]'),
                vH = document.documentElement.clientHeight || document.body.clientHeight,
                arrImgBox = [];

            for(let i=0, l=aImgBox.length; i<l; i++){
                arrImgBox.push(aImgBox[i]);
            }

            for(let i=0; i<arrImgBox.length; i++){
                let oImgBox = arrImgBox[i],
                    src = oImgBox.getAttribute('data-src'),
                    oImgWrp = oImgBox.querySelector('.listGoods-imgWrp'),
                    pos = oImgBox.getBoundingClientRect(),
                    top = pos.top,
                    bottom = pos.bottom;

                //console.log(i, arrImgBox.length, oImgBox);

                //console.log(top, bottom);
                if(top < vH && bottom > 0){ //在可视区内
                    oImgWrp.innerHTML = `<img src="${ src }" style="display: block;" width="100%" height="100%" />`;
                    oImgBox.removeAttribute('data-src');
                    arrImgBox.splice(i, 1);
                    --i;
                }
            }
        },

        //输入框自动获取焦点
        autoFocus(){
            if(this.searchVal !== ''){
                this.isShowBtnClearSearch = true;
            }
            this.$refs.searchInput.focus();
        },

        //点击取消按钮
        event_btnCancel(){
            if(this.$route.name === 'search'){
                this.$router.go(-1);
            }else{
                this.$emit('emit_closePanelSearch');
            }
        },

        //初始化history
        initSearchHistory(){
            let searchHistory = this.storage.get('searchHistory');
            if(searchHistory.errno === 0){
                this.searchValList = JSON.parse(searchHistory.data);
            }
        },

        //输入框默认提示文案
        api_getKeywordRecommend(){
            api_getKeywordRecommend().then(
                res => {
                    let data = res.body || {};
                    this.res_searchPlaceholder = data;
                },
                error => {
                    this.showAlert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            );
        },

        //获取热门栏目推荐
        api_getHotTopic(){
            api_getHotTopic().then(
                res => {
                    let data = res.body || {};
                    this.res_hotTopic = data;
                },
                res => {
                    this.showAlert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            );
        },

        //热销推荐
        api_getHotkey(){
            api_getHotkey().then(
                res => {
                    let data = res.body,
                        rp_result = data.rp_result || {};

                    this.res_hotKeys = rp_result.hotKeys || [];
                },
                error => {
                    this.showAlert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            );
        },

        //点击热搜词或搜索提示词跳转相应列表页
        event_toPageList(key, properties){
            this.setLocalStorage(key.trim(), properties); //设置localStorage

            // 打点统计： 热销推荐（除前二条），及搜索历史
            this.dp_Search(properties);

            // this.$router.push({
            //     name: 'list',
            //     query: {
            //         keyword: key
            //     }
            // }, () => {
            //     this.setLocalStorage(key.trim()); //设置localStorage
            // });
        },

        //常用分类
        api_getCommRecommend(){

            api_getCommRecommend({
                //c_device_id: 'MMMMMMMM-MMMM-MMMM-MMMM-MMMMMMMMMMMM',
                c_device_id: SEC.cookie.get('ST_FPC').split(':')[0].split('=')[1],
                c_upk: SEC.cookie.get('Sid'),
                // c_platform_type: 0,
                // c_app_ver:	'6.0.2', //版本号
            }).then(
                res => {
                    let data = res.body || {};
                    this.res_mix = data.mix || [];
                },
                error => {
                    this.showAlert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            );
        },

        //返回
        event_goBack(){
            this.$router.go(-1);
        },

        //清除搜索框值
        event_clearSearchVal(){
            this.searchVal = '';
            this.$refs.searchInput.focus();
        },

        //获取搜索结果
        event_getSearchResult(event){
            let target = event.target,
                val    = target.value.trim();

            this.searchVal = val; //去除值前后空格

            api_getSearchSuggest({
                q: val
            }).then(
                res => {
                    let data = res.body || {};
                    if(data.display.length){
                        this.res_display = data.display; //搜索推荐-联想词 新suggest
                    };
                },
                error => {
                    this.showAlert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            );
        },

        //搜索输入框失去焦点
        event_doSearchInputBlur(){
            this.$refs.searchInput.blur();
        },

        //设置localStorage
        event_setLocalStorage(event){
            let target = event.target,
                keyCode = event.keyCode,
                searchVal = this.searchVal.trim();

            //console.log(event.keyCode);console.log(event.target.value);
            if(keyCode === 13){ //回车
                //如果值为空的话
                if(searchVal !== ''){
                    //设置localStorage
                    this.setLocalStorage(searchVal, {input_mode: '空'});

                    // 打点统计
                    this.dp_Search({
                        keyword: searchVal,
                        input_mode: '空',
                        screen_name: this.from,
                        class_id: ''
                    });
                }else{
                    if(this.res_searchPlaceholder.url){ // 有可能没有数据返回
                        // window.location.href = this.res_searchPlaceholder.url;
                        try {
                            location.replace(this.res_searchPlaceholder.url);
                        } catch (e) {
                            location.href = this.res_searchPlaceholder.url;
                        }
                    }

                    // 打点统计
                    this.dp_Search({
                        keyword: this.res_searchPlaceholder.keyword || '搜索：分类 品牌 系列 商品',
                        input_mode: '空搜',
                        screen_name: this.from,
                        class_id: ''
                    });
                }

                //console.log(this.$route);
                if(this.$route.name === 'list'){ //在当前列表页下搜索，则关闭搜索框
                    this.$emit('emit_closePanelSearch');
                }
            }
        },

        //设置localStorage
        setLocalStorage(searchVal, properties){
            let searchValList = this.searchValList,
                storage = this.storage,
                index = searchValList.indexOf(searchVal),
                from = this.from;

            if(index >= 0){ //如果已存在，则先删除，再存入
                searchValList.splice(index, 1);
            }
            searchValList.push(searchVal);
            storage.set('searchHistory', JSON.stringify(searchValList), 0);

            // if(this.isPageList){
                this.$router.replace({
                    name: 'list',
                    query: {
                        keyword: searchVal,
                        _: Math.random(),
                        input_mode: properties.input_mode, // 输入方式
                        from: from //添加跳转至列表页的来源
                    }
                });
            // }else{
            //     this.$router.push({
            //         name: 'list',
            //         query: {
            //             keyword: searchVal,
            //             _: Math.random(),
            //             from: from //添加跳转至列表页的来源
            //         }
            //     });
            // }
        },

        //清除搜索历史记录
        event_clearSearchHistory(){
            this.showConfirm({
                content: '确定要删除全部历史记录吗?',
                ok: () => {
                    this.storage.remove('searchHistory');
                    this.searchValList = [];
                }
            });
        },

        // 打点统计: 热门推荐（前二项）
        event_hotTopic (properties) {
            this.dp_Search(properties);
        },
        // 打点统计: Search事件
        dp_Search (properties) {
            sensors.track(
                this.doPointEvents[0],
                properties
            );
        },

        //监听pageMain滚动时，执行搜索输入框失去焦点
        scrollPageMainDoSearchInputBlur(){
            let oPageMain = this.$refs.pageMain,
                oSearchInput = this.$refs.searchInput;

            oPageMain.fnScroll = function(){
                oSearchInput.blur();
            }
            oPageMain.addEventListener('scroll', oPageMain.fnScroll, false);
        },
        //解绑pageMain滚动事件
        event_unbindPageMainScroll(){
            let oPageMain = this.$refs.pageMain;
            oPageMain.removeEventListener('scroll', oPageMain.fnScroll, false);
        },

        showAlert(data){
            this.$store.dispatch('show_alert', data);
        },
        showConfirm(data){
            this.$store.dispatch('show_confirm', data);
        },
        ...mapMutations({
            set_alert_show: 'SET_ALERT_SHOW',
            set_alert_hide: 'SET_ALERT_HIDE',
            set_alert_data: 'SET_ALERT_DATA',
            set_confirm_show: 'SET_CONFIRM_SHOW',
            set_confirm_hide: 'SET_CONFIRM_HIDE',
            set_confrim_data: 'SET_CONFIRM_DATA'
        }),
        ...mapActions([
            'show_alert',
            'show_confirm'
        ])
    },
    watch: {
        //监听输入框值的变化, 显示隐藏结果
        searchVal(val){
            if(val === ''){
                this.isShowBtnClearSearch = false;
                this.isShowSearchResult = false;
                this.isPageHidden = false;
            }else{
                this.isShowBtnClearSearch = true;
                this.isShowSearchResult = true;
                this.isPageHidden = true;
            }
        }
    },
    components: {
        MDialog,
        MGoodsList
    }
}
</script>

<style lang="scss" scoped>
.page-search {
}
.search {
    position: absolute;
    top: 0;
    z-index: 100;

    @include box-sizing(border-box);
    padding: toRem(24) toRem(110) toRem(24) toRem(30);
    max-width: toRem(750);
    width: 100%;
    background: $color-white;

    &-iptBox,
    &-btnCancel {
        height: toRem(64);
    }

    &-iptBox {
        padding: 0 toRem(64) 0 toRem(80);
        background: $bg-main;
    }
    &-text {
        margin-top: toRem(11);
        width: 100%;
        height: toRem(42);

        font-size: toRem(30);
        line-height: toRem(42);

        color: #color-main;
        background: transparent;
    }
    &-icon,
    &-clearInput,
    &-btnCancel {
        position: absolute;
    }
    &-icon {
        top: toRem(34);
        left: toRem(44);
        font-size: toRem(45);
    }
    &-clearInput {
        top: toRem(24);
        right: toRem(110);

        width: toRem(64);
        height: toRem(64);

        line-height: toRem(64);
        text-align: center;

        .iconfont {
            font-size: toRem(28);

            color: #CCC;
        }
    }
    &-btnCancel {
        top: toRem(24);
        right: toRem(2);
        width: toRem(108);

        font-size: toRem(30);
        text-align: center;
        line-height: toRem(64);
    }
}
.page-main {
    overflow-x: hidden;
    overflow-y: auto;

    position: absolute;
    top: toRem(110);
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 50;
    max-width: toRem(750);
    background-color: #FFF;

    &Cnt {
        background: $bg-main;
    }
    & .mod-area:first-child {
        margin-top: toRem(-24);
    }
    &--bgWhite {
        background: $bg-white;
    }
    &--hidden {
        overflow: hidden;
    }
}

.mod-area {
    padding: 0 toRem(30);

    background: $bg-white;
}
.mod-head {
    position: relative;
    padding: toRem(40) 0 toRem(30);
    height: toRem(42);

    font-size: toRem(30);
    line-height: toRem(42);
}
.btn-clearHistory {
    position: absolute;
    top: toRem(40);
    right: 0;

    width: toRem(40);
    height: toRem(40);

    line-height: toRem(40);
    text-align: center;

    .iconfont {
        font-size: toRem(28);

        color: #999;
    }
}
.listTxt {
    @extend %flex-horizontal-between;

    padding-bottom: toRem(34);

    font-size: toRem(26);
    text-align: center;
    line-height: toRem(60);

    &-item {
        margin-bottom: toRem(16);

        width: toRem(220);
        height: toRem(60);

        background: $bg-F8F8;

        & a {
            overflow: hidden;
            display: block;
            padding: 0 toRem(10);
            @extend %text-ellipsis;
        }
    }
    &--hot {
        padding-bottom: 0;

        li {
            @include box-sizing(border-box);
            border: 1px solid $color-orange;
            width: toRem(338);
            height: toRem(60);

            color: $color-orange;
            background: transparent;
        }
        & a {
            height: toRem(70);
        }
    }
    &--normal {
        @extend %flex-horizontal-start;

        li {
            overflow: hidden;

            margin-right: toRem(16);
            padding: 0 toRem(24);
            width: auto;

            @extend %text-ellipsis;
        }
    }
}

.mode-area--searchHistory {
    padding-bottom: toRem(34);
    ul {
        overflow: hidden;
        padding-bottom: 0;
        max-height: toRem(228);
    }
}
.mod-like {
    background: $bg-white;
    & .mod-head {
        margin: 0 toRem(30);
    }
}

.brand {
    position: relative;
    border-bottom: 1px solid $bd-color;
    margin: 0 toRem(30);

    &-item {
        padding: toRem(40) 0;
    }
    &-row {
        height: toRem(44);

        line-height: toRem(44);
    }
    &-name,
    &-size {
        color: #1A191E;
    }
    &-name {
        overflow: hidden;
        margin-right: toRem(132);

        font-size: toRem(34);
        @extend %text-ellipsis;
    }
    &-enter {
        position: absolute;
        top: toRem(40);
        right: 0;

        font-size: toRem(28);
    }
    &-size {
        height: toRem(38);

        font-size: toRem(26);
        line-height: toRem(38);
    }
}
.schResList {
    margin: 0 toRem(30);
    padding-top: toRem(40);

    li {
        padding-bottom: toRem(50);

        font-size: toRem(30);
        line-height: toRem(42);
        word-wrap: break-word;
        word-break: break-all;
    }
    a {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MSearch/index.vue